import PropTypes from 'prop-types';
import { Box, Typography, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { isNil } from 'lodash';
import useLocales from '../../hooks/useLocales';
import { useSelector } from '../../redux/store';

GeoMapPopUp.propTypes = {
  hoverInfo: PropTypes.object
};

export default function GeoMapPopUp({ hoverInfo }) {
  const { translate: t } = useLocales();
  const { mapIsFetching } = useSelector((state) => state.frontend);
  const theme = useTheme();

  return (
    hoverInfo !== null && (
      <Box>
        <Box
          sx={{
            mb: 1,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {mapIsFetching && (
            <Box sx={{ width: '100%' }}>
              <LinearProgress color="inherit" />
            </Box>
          )}
          {!isNil(hoverInfo.feature) &&
          !isNil(hoverInfo.feature.geometry) &&
          !isNil(hoverInfo.feature.geometry.type) &&
          hoverInfo.feature.geometry.type === 'Point' ? (
            <Box key={`popUp-${hoverInfo.feature.properties.id}`}>
              <Box
                sx={{
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Typography
                  variant="subtitle2"
                  color={
                    !isNil(hoverInfo.feature.properties.group) && !isNil(hoverInfo.feature.properties.group.color)
                      ? hoverInfo.feature.properties.group.color
                      : theme.palette.primary.main
                  }
                >
                  {hoverInfo.feature.properties.full_name}
                </Typography>
              </Box>
              {!isNil(hoverInfo.feature.properties.group) && hoverInfo.feature.properties.group !== '' && (
                <Typography component="div" variant="caption">
                  <strong>{t('home.entityType')}:</strong> {hoverInfo.feature.properties.group.name}
                </Typography>
              )}
              {!isNil(hoverInfo.feature.properties.address) && hoverInfo.feature.properties.address !== '' && (
                <Typography component="div" variant="caption">
                  <strong>{t('home.entityAddress')}:</strong> {hoverInfo.feature.properties.address}
                </Typography>
              )}
              {!isNil(hoverInfo.feature.properties.contact_person) &&
                hoverInfo.feature.properties.contact_person !== '' && (
                  <Typography component="div" variant="caption">
                    <strong>{t('home.entityContactPerson')}:</strong> {hoverInfo.feature.properties.contact_person}
                  </Typography>
                )}
              {!isNil(hoverInfo.feature.properties.phone_number) && hoverInfo.feature.properties.phone_number !== '' && (
                <Typography component="div" variant="caption">
                  <strong>{t('home.entityPhoneNumber')}:</strong> {hoverInfo.feature.properties.phone_number}
                </Typography>
              )}
              {!isNil(hoverInfo.feature.properties.email) && hoverInfo.feature.properties.email !== '' && (
                <Typography component="div" variant="caption">
                  <strong>{t('home.entityContactEmail')}:</strong> {hoverInfo.feature.properties.email}
                </Typography>
              )}
              {!isNil(hoverInfo.feature.properties.pictures) &&
                JSON.parse(hoverInfo.feature.properties.pictures).length > 0 && (
                  <Box
                    component="img"
                    alt={hoverInfo.feature.properties.full_name}
                    src={JSON.parse(hoverInfo.feature.properties.pictures)[0]}
                    sx={{
                      mt: 1,
                      height: 120,
                      width: '100%',
                      borderRadius: 1,
                      objectFit: 'cover'
                    }}
                  />
                )}
            </Box>
          ) : (
            <Box key={`popUp-${hoverInfo.feature.properties.id}`}>
              <Typography component="div" variant="caption">
                <strong>{t('home.entityName')}:</strong> {hoverInfo.feature.properties.name}
              </Typography>
              <Typography component="div" variant="caption">
                <strong>{t('home.entityShortName')}: </strong>
                {hoverInfo.feature.properties.short_name}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    )
  );
}
